import actions from './actions';

const initialState = {
    tickets: [],
    paginationInfo: {},
    ticketDetail: null,
};

export default function soporteReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_TICKETS_SUCCESS:
            return {
                ...state,
                tickets: action.payload.tickets,
                paginationInfo: action.payload.paginationInfo,
            }
        case actions.GET_TICKET_DETAIL_SUCCESS:
            return {
                ...state,
                ticketDetail: action.payload,
            }
        default:
            return state;
    }
}
